import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { firestore } from '../services/firebase';

export const useFilters = () => {
  const [filters, setFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const q = query(
      collection(firestore, 'filters'),
      where('archived', '==', false)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (snapshot.empty) {
        setFilters([]);
        setIsLoading(false);
        return;
      }

      const withOrder = snapshot.docs.map((doc) => {
        const { name, slug, order } = doc.data();
        // `id` (doc do Firestore) é o que permite regravar a ordem quando o
        // admin reordena os filtros arrastando na Main.
        return { id: doc.id, label: name, value: slug, order };
      });

      withOrder.sort((a, b) => a.order - b.order);

      const filtros = withOrder.map(({ id, label, value }) => ({
        id,
        label,
        value,
      }));

      setFilters(filtros);
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return {
    data: filters,
    isLoading,
  };
};
